import React from "react";
import { Header, Grid } from "semantic-ui-react";
import { UserSurveySectionResultDto } from "../../models/userSurveySectionResultDto";
import ProficiencyLevelIconControl from "../Common/ProficiencyLevelIconControl";
import { useStore } from "../../stores/store";

interface Props {
  sections: UserSurveySectionResultDto[];
}

export default function BarChart({ sections }: Props) {
  const { commonStore } = useStore();
  const getColor = (index: number): string => {
    switch (index) {
      case 0:
        return "#ef7e2b";
      case 1:
        return "#299947";
      case 2:
        return "#3f85c6";
      case 3:
        return "#1da2a3";
      case 4:
        return "#623785";
      case 5:
        return "#d3375a";
      default:
        return "#d3375a";
    }
  };

  const getImage = (level: string): string => {
    let levelLowerCase = level.toLowerCase();
    return `/assets/${levelLowerCase}.svg`;
  };

  const getLevelSymbol = (level: string): string => {
    if (level == null) return "";
    let levelLowerCase = level.toLowerCase();
    switch (levelLowerCase) {
      case "newcomer":
        return "A1";
      case "explorer":
        return "A2";
      case "integrator":
        return "B1";
      case "expert":
        return "B2";
      case "leader":
        return "C1";
      case "pioneer":
        return "C2";
      default:
        return "";
    }
  };

  return (
    <>
      <div id="bar-chart">
        <Grid>
          {sections &&
            sections.length > 0 &&
            sections.map((section, index) => (
              <Grid.Row
                key={section.sectionId}
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "inherit",
                  alignItems: "stretch",
                  width: "100%",
                  padding: "0",
                  paddingTop: "1rem",
                  paddingBottom: "1rem",
                }}
              >
                <Grid.Column width={14} style={{ width: "85%", paddingRight: "1rem" }}>
                  <Header as="h4">{commonStore.getUserSurveySectionTitle(section)}</Header>
                  <div className="w3-light-grey w3-xxlarge" style={{ background: "#f1f1f1" }}>
                    <div
                      className="w3-container"
                      style={{
                        width: `${section.scorePercentage}%`,
                        padding: "15px 0px",
                        background: getColor(index),
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                      {section.scorePercentage} %
                    </div>
                  </div>
                </Grid.Column>
                <Grid.Column width={2} style={{ width: "12%", textAlign: "center" }}>
                  <Header as="h4" style={{}} textAlign="center">
                    {getLevelSymbol(section.level)}
                  </Header>
                  <div
                    style={{
                      background: getColor(index),
                      width: "55px",
                      borderRadius: "10px",
                      margin: "0 auto",
                    }}
                  >
                    <ProficiencyLevelIconControl level={section.level} />
                  </div>
                </Grid.Column>
              </Grid.Row>
            ))}
        </Grid>
      </div>
    </>
  );
}
